import { Link } from 'react-router-dom';
import { Instagram, Twitter, Facebook, Linkedin } from 'lucide-react';
import logoImage from '../../assets/logo.svg';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 transition-colors duration-200">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-100 dark:bg-gray-700 rounded-full">
                <img
                  src={logoImage}
                  alt="FemSportNet Logo"
                  className="w-8 h-8 object-contain"
                />
              </div>
              <span className="text-xl font-bold text-gray-900 dark:text-white">FemSportNet</span>
            </div>
            <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
              Empowering female athletes through community, resources, and opportunities.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-500 hover:text-green-500 dark:text-gray-400 dark:hover:text-green-400 transition-colors duration-200">
                <Instagram size={20} />
                <span className="sr-only">Instagram</span>
              </a>
              <a href="#" className="text-gray-500 hover:text-green-500 dark:text-gray-400 dark:hover:text-green-400 transition-colors duration-200">
                <Twitter size={20} />
                <span className="sr-only">Twitter</span>
              </a>
              <a href="#" className="text-gray-500 hover:text-green-500 dark:text-gray-400 dark:hover:text-green-400 transition-colors duration-200">
                <Facebook size={20} />
                <span className="sr-only">Facebook</span>
              </a>
              <a href="#" className="text-gray-500 hover:text-green-500 dark:text-gray-400 dark:hover:text-green-400 transition-colors duration-200">
                <Linkedin size={20} />
                <span className="sr-only">LinkedIn</span>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">Platform</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/feed" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Feed
                </Link>
              </li>
              <li>
                <Link to="/photos" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Photos
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Discover Athletes
                </Link>
              </li>
              <li>
                <Link to="/messages" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Messaging
                </Link>
              </li>
              <li>
                <Link to="/marketplace" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Marketplace
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/press" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Press
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/accessibility" className="text-gray-600 dark:text-gray-300 hover:text-green-500 dark:hover:text-green-400 text-sm transition-colors duration-200">
                  Accessibility
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-gray-500 dark:text-gray-400 text-sm text-center md:text-left mb-4 md:mb-0">
              &copy; {currentYear} FemSportNet. All rights reserved.
            </p>
            
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Made with ❤️ for female athletes worldwide
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
